/**
 * @file index
 * @author dingzhenyue
 * @desc 法律角色拦截，未认证的律师进行页面拦截
 */
import store from '@/store/index';


export const lawyerNotCertifiedIntercept = (to, from, next) => {
    let lawStore = store.state.lawStore || {};
    let auditStatus = (lawStore.userInfoNew && lawStore.userInfoNew.lawyer_info || {}).audit_status;
    // 已认证('4')或资质数据未加载(undefined/null)时不拦截
    if (auditStatus === undefined || auditStatus === null || String(auditStatus) === '4') {
        next();
        return;
    }
    // 资质未认证：首页正常展示，我的认证/业务中心放行（按路由名 + 路径双重匹配，容忍尾斜杠）
    const path = (to.path || '').replace(/\/+$/, '') || '/';
    const isAllow = ['lawinfo', 'material', 'businessCenter'].includes(to.name)
        || ['/lawinfo', '/material', '/businessCenter'].includes(path);
    if (isAllow) {
        next();
        return;
    }
    // 首次进入(无来源路由)兜底落到首页，避免直接进首页被弹到认证页
    if (!from || !from.name) {
        next({name: 'lawinfo'});
        return;
    }
    // 其余入口（侧边栏各 tab）统一跳「我的认证」
    next('/material');
};
